import gql from "graphql-tag";

export const deActivateOrganizationMemberState = gql`
  mutation DeActivateOrganizationMember($input: DeActivateOrganizationMemberRequestInput) {
    DeActivateOrganizationMember(input: $input) {
      success
    }
  }
`;
